<template>
    <div>
        <div class="serial-footer">
            <div class="serial-footer__button-container"
            v-if="campaignGroup == '5' || campaignGroup == '6' || campaignGroup == '7' || campaignGroup == 'default'">
                <button 
                    class="serial-footer__button serial-footer__button--primary"
                    @click="clickButton('clickBackToPrivilege')">
                    {{ lbl.btn_privilege }}
                </button>
                <button 
                    class="serial-footer__button serial-footer__button--secondary"
                    @click="clickButton('clickToMyCoupon')"
                    v-if="!isShowCancelRedemption">
                    {{ lbl.btn_coupon }}
                </button>
                <!-- <button 
                    class="serial-footer__button serial-footer__button--secondary"
                    @click="clickButton('clickCancelRedemption')"
                    v-if="isShowCancelRedemption">
                    Cancel redemption
                </button> -->
            </div>
            
            <button 
                class="serial-footer__button serial-footer__button--primary"
                @click="clickButton('clickContinueToProceed')"
                v-else>
                {{ lbl.footer_close || 'ถัดไป'}}
            </button>
            <!-- old code -->
            <!-- <button 
                class="serial-footer__button serial-footer__button--primary"
                @click="clickButton('clickClose')"
                v-if="isShowFooterClose">
                {{lbl.footer_close || 'Back to Privilege'}}
            </button>
            <button 
                class="serial-footer__button serial-footer__button--secondary"
                @click="clickButton('clickCancelRedemption')"
                v-if="isShowCancelRedemption">
                {{campaignGroup == '9' ? lbl.footer_cancel_group_9 : lbl.footer_cancel_redemption || 'My coupon'}}
            </button> -->
            <!-- <div class="serial-footer__logo">
                <img src="@/assets/bzbslogo/buzzebees-logo-dark@3x.png"/>
            </div> -->
        </div>
    </div>
</template>
<script>
// import SecondaryButton from "../../../Button/SecondaryButton.vue";
export default {
    name: "SerialFooter",
    components: {
        // SecondaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        
    },
    props: {
        lbl: Object,
        controller: Object,
        isShowFooterClose: Boolean,
        isShowCancelRedemption: Boolean,
        campaignGroup: String
    },
    methods: {
        clickButton: function (emitName) {
            this.$emit(emitName);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.serial-footer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: {
        top: 20px;
        left: 0;
        right: 0;
        bottom: 20px;
    };

    .serial-footer__button {
        width: 100%;
        padding: 14px;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s;
        border: none;

        &--primary {
            background-color: $color-red;
            color: #FFFFFF;
            font-weight: 600;

            // &:hover {
            //     background-color: $color-red-2;
            // }

            // &:active {
            //     background-color: $color-red;
            // }
        }

        &--secondary {
            background-color: $color-white;
            color: $color-red;
            font-weight: 500;

            // &:hover {
            //     background-color: $color-red-2;
            // }

            // &:active {
            //     background-color: #FEE2E2;
            // }
        }
    }

    // .serial-footer__logo {
    //     margin-top: 8px;
    //     img {
    //         display: block;
    //         height: 20px;
    //         margin: {
    //             left: auto;
    //             right: auto;
    //         };
    //     }
    // }
}
</style>
